import Header from '../components/Header';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step456 from './components/Step456';
import Step7 from './components/Step7';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Crum from '@/components/Crum';

export enum Mm100Page {
    Scenery,
    Type,
    Appliances,
    PowerKits,
    Combo,
    SolarPanel,
    Result,
}

export default function Mm100Calculator() {
    const { useState, useLang, useRouter, useEffect } = useGlobal();
    const { t } = useLang('shared');
    const router = useRouter();
    const { locale } = router;
    const stepTitle = ['scenery', 'type', 'appliances', 'power_hub', 'combo', 'solar_panel', 'result'];
    const [calcObj, setCalcObj] = useState({
        currentStep: 1,
        totalStep: 7,
        stepTitle,
        currentPage: Mm100Page.Scenery,
    });

    useEffect(() => {
        if (sessionStorage) {
            const session = sessionStorage.getItem(`calculatorMM100_${locale}`);
            if (session) {
                setCalcObj(JSON.parse(session));
            }
        }
    }, []);

    useEffect(() => {
        if (window) {
            window.addEventListener('beforeunload', beforeunload);
        }
        return () => window.removeEventListener('beforeunload', beforeunload);
    }, [calcObj]);

    const beforeunload = () => {
        sessionStorage.setItem(`calculatorMM100_${locale}`, JSON.stringify(calcObj));
    };

    const breadcrumbData = [
        { name: t('calculators.mm100.crum_home'), link: '/' },
        { name: t('calculators.mm100.crum_mm100'), link: '/ecoflow-power-kits/series' },
        { name: t('calculators.mm100.crum_calculator') },
    ];

    const updateCalcObj = (obj: any, again = false) => {
        if (again) {
            sessionStorage.removeItem('calculatorMM100');
            setCalcObj({ currentStep: 1, totalStep: 7, stepTitle, currentPage: Mm100Page.Scenery });
        } else {
            setCalcObj({ ...calcObj, ...obj });
        }
    };

    useEffect(() => {
        if (calcObj?.currentPage !== Mm100Page.SolarPanel) {
            window.scrollTo(0, 0);
        }
    }, [calcObj?.currentPage]);

    const onBack = () => {
        switch (calcObj.currentPage) {
            case Mm100Page.Type:
                return updateCalcObj({
                    currentStep: 1,
                    currentPage: Mm100Page.Scenery,
                    type: null,
                    stepTitle: [calcObj.stepTitle[0], 'type', ...calcObj.stepTitle.slice(-5)],
                });
            case Mm100Page.Appliances:
                return updateCalcObj(
                    calcObj?.scene === 'others'
                        ? {
                              currentStep: 1,
                              currentPage: Mm100Page.Scenery,
                              appliances: null,
                              allAppliances: null,
                              totalPower: null,
                          }
                        : {
                              currentStep: 2,
                              currentPage: Mm100Page.Type,
                              appliances: null,
                              totalPower: null,
                          },
                );
            case Mm100Page.PowerKits:
            case Mm100Page.Combo:
            case Mm100Page.SolarPanel:
                return updateCalcObj({
                    currentStep: calcObj?.scene === 'others' ? 2 : 3,
                    currentPage: Mm100Page.Appliances,
                    totalDiscount: null,
                    totalOriginal: null,
                    selectedPower: null,
                    selectedCombo: null,
                    selectedInstall: null,
                    solarOptions: null,
                    bundle: null,
                });
            case Mm100Page.Result:
                const steps = calcObj?.stepTitle?.length;
                return updateCalcObj({
                    currentStep: calcObj?.selectedSolar ? steps - 1 : calcObj?.selectedCombo ? steps - 2 : steps - 3,
                    currentPage: calcObj?.selectedSolar ? Mm100Page.SolarPanel : calcObj?.selectedCombo ? Mm100Page.Combo : Mm100Page.PowerKits,
                });
        }
    };

    return (
        <div className={`calculatorMm100 ${css.calculatorMm100} container`}>
            <h1 className="visuallyhidden">EcoFlow Calculator</h1>
            <div className="calculator-crum">
                <Crum data={breadcrumbData} backgroundColor={'#fff'} />
            </div>
            <div className="calculatorMm100-commonHeader">
                <Header breadcrumbData={breadcrumbData} calcObj={calcObj} onBack={onBack} />
            </div>
            <div className="calculatorMm100-stepComponents">
                {calcObj.currentPage === Mm100Page.Scenery && <Step1 data={calcObj} callBack={updateCalcObj} />}
                {calcObj.currentPage === Mm100Page.Type && <Step2 data={calcObj} callBack={updateCalcObj} />}
                {calcObj.currentPage === Mm100Page.Appliances && <Step3 data={calcObj} callBack={updateCalcObj} />}
                {[Mm100Page.PowerKits, Mm100Page.Combo, Mm100Page.SolarPanel].includes(calcObj.currentPage) && (
                    <Step456 data={calcObj} callBack={updateCalcObj} />
                )}
                {calcObj.currentPage === Mm100Page.Result && <Step7 data={calcObj} callBack={updateCalcObj} />}
            </div>
        </div>
    );
}
